<template>
  <div class="p-2">
    <h3>{{ $t('favorites.add_favorite') }}</h3>
    <div class="col-12"  style="height: 20em">
        <open-contract-filter
          :from="now"
          :show-title="true"
          :show-company="false"
          :apply-padding="false"
          @contract-selected="setContract"
        />
    </div>
    <div class="col-12 d-flex justify-content-end mt-4">
      <button
        class="btn btn-secondary form-button"
        @click.stop="$emit('close')"
      >
        {{ $t('common.cancel') }}
      </button>
      <button
        class="btn btn-success form-button"
        :disabled="!id"
        @click.stop="save"
      >
        <span>
          {{ $t('common.save') }}
        </span>
      </button>
    </div>
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import OpenContractFilter from "@/components/contract/OpenContractFilter";

export default {
    name: 'FavoritesSelector',
    components: {OpenContractFilter},
    mixins: [restApi],
    data: function () {
        return {
            type: 1,  // Contract
            id: null
        }
    },
    computed: {
        now() {
            return new Date().toISOString();
        },
    },
    methods: {
        setContract(contract) {
            this.id = contract.id
        },

        save() {
            this.$emit('newFavorite', this.type, this.id)
        }
    }
}
</script>
